module.exports = __webpack_public_path__ + "img/trousse.89d5aae6.png";